import * as o from "react";
import e from "../lib/IconBase.es.js";
import n from "../defs/ChartBarHorizontal.es.js";
const r = o.forwardRef((a, t) => /* @__PURE__ */ o.createElement(e, { ref: t, ...a, weights: n }));
r.displayName = "ChartBarHorizontalIcon";
const c = r;
export {
  c as ChartBarHorizontal,
  r as ChartBarHorizontalIcon
};
